/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settingsnav_Systempreferences2Inputs */

const zh_settingsnav_systempreferences2 = /** @type {(inputs: Settingsnav_Systempreferences2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`系统设置`)
};

const en_settingsnav_systempreferences2 = /** @type {(inputs: Settingsnav_Systempreferences2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System Settings`)
};

const es_settingsnav_systempreferences2 = /** @type {(inputs: Settingsnav_Systempreferences2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración del sistema`)
};

/**
* | output |
* | --- |
* | "System Settings" |
*
* @param {Settingsnav_Systempreferences2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const settingsnav_systempreferences2 = /** @type {((inputs?: Settingsnav_Systempreferences2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsnav_Systempreferences2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_settingsnav_systempreferences2(inputs)
	if (locale === "en") return en_settingsnav_systempreferences2(inputs)
	return es_settingsnav_systempreferences2(inputs)
});
export { settingsnav_systempreferences2 as "settingsNav_systemPreferences" }